import { getUrlParams, commonParseQuery, parseJson } from './common-utils';
import { getPlaceDetailsServerSide } from '../../dweb-cars/shared/pages/SeoPage/redux/thunks';

export const parseTime = (time: string) => time + (parseInt(time, 10) < 12 ? ' AM' : ' PM');

const parseResultsPageUrlToConfig = async (url) => {
  const searchParams = getUrlParams(url);
  const { qryParams = '{}', filters = '', utm_medium = "",utm_campaign="" } = searchParams;
  const parsedJson = parseJson(qryParams);
  const { 
    s_n, 
    s_i, 
    d_n, 
    d_i, 
    s_t, 
    e_t, 
    s_a,
    d_a,
    s_lat,
    s_long,
    d_lat,
    d_long,
    s_pin,
    d_pin,
    s_gc,
    d_gc,
    s_is_city,
    d_is_city,
    s_is_airport,
    d_is_airport,
    t_t = "ONE_WAY", 
    rf = "ow", 
    s_c = "", 
    off = 0, 
    r_off = 0, 
    pc = "", 
    flow = "", 
    isSeo = false, 
    package_id = '', 
    d_c = '',
    s_l = {}, 
    d_l = '', 
    s_s, 
    d_s, 
    stops
  } = parsedJson;
  const { newSDate, newSTime, newEDate, newETime } = commonParseQuery({ s_t, e_t, off, r_off });
  
  // Initialize source and destination with existing data
  let sourceData = {
    name: s_n,
    place_id: s_i,
    city_name: s_c,
    locus: s_l,
    state: s_s,
    address: s_a,
    latitude: s_lat,
    longitude: s_long,
    pincode: s_pin,
    google_city: s_gc,
    is_city: s_is_city,
    is_airport: s_is_airport
  };

  let destinationData = {
    name: d_n,
    place_id: d_i,
    city_name: d_c,
    locus: d_l,
    state: d_s,
    address: d_a,
    latitude: d_lat,
    longitude: d_long,
    pincode: d_pin,
    google_city: d_gc,
    is_city: d_is_city,
    is_airport: d_is_airport
  };

  // Fetch source place details if latitude/longitude missing and not hourly rental
  if ((!s_lat || !s_long) && s_i) {
    try {
      const sourcePlaceDetails = await getPlaceDetailsServerSide(s_i);
      sourceData = { ...sourceData, ...sourcePlaceDetails };
    } catch (error) {
      console.warn('Failed to fetch source place details:', error);
    }
  }

  // Fetch destination place details if latitude/longitude missing and not hourly rental
  if ((!d_lat || !d_long) && !package_id?.length && d_i) {
    try {
      const destinationPlaceDetails = await getPlaceDetailsServerSide(d_i);
      destinationData = { ...destinationData, ...destinationPlaceDetails };
    } catch (error) {
      console.warn('Failed to fetch destination place details:', error);
    }
  }

  const parseData = {
    startDate: {
      date: newSDate,
      time: newSTime[0]
    },
    endDate: {
      date: newEDate,
      time: newETime[1]
    },
    source: sourceData,
    destination: destinationData,
    tripType: {
      name: (e_t && !stops?.length) || r_off ? 'ROUND_TRIP' : t_t,
      rf: (e_t && !stops?.length) || r_off ? 'rt' : rf
    },
    filters: null,
    flow,
    pc,
    isSeo: !!isSeo,
    package_id
  };
  if (filters) {
    const parsedJson = parseJson(filters);
    if (Object.keys(parsedJson).length > 0) {
      parseData['filters'] = parsedJson;
    }
  }

  if (stops?.length) {
    const newStopOvers = await Promise.all(stops.map(async (details) => {
      let stopValue = {
        place_id: details?.value?.place_id,
        city_name: details?.value?.region,
        name: details?.value?.description,
        address: details?.value?.address,
        latitude: details?.value?.latitude,
        longitude: details?.value?.longitude,
        pincode: details?.value?.pincode,
        google_city: details?.value?.google_city,
        is_city: details?.value?.is_city,
        is_airport: details?.value?.is_airport
      };

      // Fetch place details if latitude/longitude missing
      if ((!details?.value?.latitude || !details?.value?.longitude) && details?.value?.place_id) {
        try {
          const stopPlaceDetails = await getPlaceDetailsServerSide(details?.value?.place_id);
          stopValue = { ...stopValue, ...stopPlaceDetails };
        } catch (error) {
          console.warn('Failed to fetch stop place details:', error);
        }
      }

      return {
        id: details?.id,
        value: stopValue
      };
    }));
    parseData['stopOvers'] = newStopOvers;
  }

  if (utm_medium && utm_medium === 'cpc') {
    parseData['sem_flow'] = true;
    parseData['utm_medium'] = utm_medium;
    parseData['utm_campaign'] = utm_campaign;
    
  }
  const srcConfig = ["ChIJARFGZy6_wjsRQ-Oenb9DjYI","ChIJpQoX1dIJGToRqD-zaCsOWPw","ChIJtRyXL69ZqDsRgtI-GB7IwS8","ChIJL_P_CXMEDTkRw0ZdG-0GVvw","ChIJ2UEvfIUNdDkRQjtSqTjvSng"]
  const destConfig = ["ChIJwe1EZjDG5zsRaYxkjY_tpF0","ChIJleRWAhjEGToR1_rBMIudakk","ChIJjdfztYS9qDsRQj8-yRTbmxc","ChIJL_P_CXMEDTkRw0ZdG-0GVvw","ChIJ2UEvfIUNdDkRQjtSqTjvSng"]
  if(s_i && srcConfig.indexOf(s_i) !== -1 && d_i && destConfig.indexOf(d_i) !== -1){
    parseData['showQueryCB'] = true;
  }
  return parseData;
}


export default parseResultsPageUrlToConfig;